import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatMXN = (value) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0);

export const convert = (mxn, currency, rates) => {
  if (currency === "MXN" || !rates) return mxn;
  const r = rates[currency];
  if (!r) return mxn;
  return mxn * r;
};

export const formatCurrency = (mxn, currency, rates) => {
  if (currency === "MXN") return formatMXN(mxn);
  const val = convert(mxn, currency, rates);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(val || 0);
};
